import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../../api";

import ParadigmaAsyncSeeker from "../../../components/ParadigmaAsyncSeeker/ParadigmaAsyncSeeker.js"
import SelectSimplePoloPetroquimico from './SelectSimplePoloPetroquimico.js';

import { Label, Input, FormFeedback } from 'reactstrap';
import { validationInputProps } from "../../../utils/inputValidation";

class Create extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    static propTypes = {
        onSubmit: PropTypes.func.isRequired,
        label: PropTypes.string,
        buttonClass: PropTypes.string
    }

    render() {
        return (
            <ParadigmaModal
                postUrl={api.clientes.empresas.create}
                onSubmit={(res) => this.props.onSubmit(res)}
                successMessage={"La Empresa ha sido creada con éxito."}
                title={"Nueva Empresa"}
                buttonIcon={"fa fa-plus fa-lg"}
                buttonLabel={this.props.label}
                saveButton={true}
                buttonTitle={"Nueva Empresa"}
                closeButton={true}
                buttonClass={this.props.buttonClass}
                className={"ui-modal-dialog ui-modal-lg"}>
                <div className="ui-form">
                    <div className="ui-section-grid">
                        <section className="ui-section-block">
                            <p className="ui-section-label">Identificación</p>
                            <div className="ui-row-1">
                                <div className="ui-field">
                                    <Label>Nombre</Label>
                                    <Input type="text" name="nombre" autoFocus data-auto-focus="true"></Input>
                                    <FormFeedback className="col-12"></FormFeedback>
                                </div>
                            </div>
                            <div className="ui-row-1">
                                <div className="ui-field">
                                    <Label>Razón Social</Label>
                                    <Input type="text" name="razonSocial"></Input>
                                    <FormFeedback className="col-12"></FormFeedback>
                                </div>
                            </div>
                            <div className="ui-row-1">
                                <div className="ui-field">
                                    <Label>CUIT</Label>
                                    <Input type="text" name="cuit" {...validationInputProps.cuit}></Input>
                                    <FormFeedback className="col-12"></FormFeedback>
                                </div>
                            </div>
                        </section>

                        <section className="ui-section-block">
                            <p className="ui-section-label">Clasificación</p>
                            <div className="ui-row-1">
                                <div className="ui-field">
                                    <Label>Clasificación</Label>
                                    <ParadigmaAsyncSeeker fieldName={"clasificacion_id"} url={api.clientes.clasificacion.select} />
                                </div>
                            </div>
                            <div className="ui-row-1">
                                <div className="ui-field">
                                    <Label>Rubro</Label>
                                    <ParadigmaAsyncSeeker fieldName={"rubro_id"} url={api.clientes.rubros.select} />
                                </div>
                            </div>
                            <div className="ui-row-1">
                                <div className="ui-field">
                                    <Label>Polo Petroquímico</Label>
                                    <SelectSimplePoloPetroquimico />
                                </div>
                            </div>
                        </section>

                        <section className="ui-section-block">
                            <p className="ui-section-label">Contacto</p>
                            <div className="ui-row-2">
                                <div className="ui-field">
                                    <Label>Email</Label>
                                    <Input type="text" name="email"></Input>
                                    <FormFeedback className="col-12"></FormFeedback>
                                </div>
                                <div className="ui-field">
                                    <Label>Teléfono</Label>
                                    <Input type="text" name="telefono" ></Input>
                                    <FormFeedback className="col-12"></FormFeedback>
                                </div>
                            </div>
                            <div className="ui-row-1">
                                <div className="ui-field">
                                    <Label>País</Label>
                                    <ParadigmaAsyncSeeker fieldName={"pais_id"} url={api.misc.paises.select} />
                                </div>
                            </div>
                        </section>

                        <section className="ui-section-block">
                            <p className="ui-section-label">Observaciones</p>
                            <div className="ui-row-1">
                                <div className="ui-field">
                                    <Label>Observaciones</Label>
                                    <Input type="textarea" name="observaciones" rows="5"/>
                                    <FormFeedback className="col-12"></FormFeedback>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </ParadigmaModal>
        );
    }
}

export default Create;



// WEBPACK FOOTER //
// ./src/views/clientes/Empresas/Create.js